// The logged-in player's id for this page. The socket cookie can outlive the
// session it came from, so it only counts when the server rendered the page
// for a logged-in player (the layout's isLoggedIn). Otherwise the page would
// start up as that player, the server would answer 401, and the page would be
// sent to log in again and again.
export function loggedInUserId({ serverSaysLoggedIn, cookieUserId }) {
	return serverSaysLoggedIn === false ? undefined : cookieUserId;
}
